@if (section()) {
  <h2 class="text-2xl font-bold mb-2">{{ section().title }}</h2>

  <div
    [innerHTML]="section().content"
    class="description"
  ></div>
}
